import { BorderColors, ForegroundColors } from "@abel-technologies-as/components";
import styled from "styled-components";

const EventContainer = styled.div`
	padding: 23px 0 16px 0;
	border-bottom: 1px solid ${BorderColors.Secondary};
`;

const GreenDot = styled.div`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${ForegroundColors.SuccessSecondary};
`;

export { EventContainer, GreenDot };
